import { render, staticRenderFns } from "./Workdepartmentbudgetstatistical.vue?vue&type=template&id=1b23ec3d&scoped=true&"
import script from "./Workdepartmentbudgetstatistical.vue?vue&type=script&lang=js&"
export * from "./Workdepartmentbudgetstatistical.vue?vue&type=script&lang=js&"
import style0 from "./Workdepartmentbudgetstatistical.vue?vue&type=style&index=0&id=1b23ec3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b23ec3d",
  null
  
)

export default component.exports